<div class="organization-popup">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ data?.businessName ? data?.businessName : "Add Organization" }}
    </h4>
    <div class="d-flex justify-content-end ms-auto">
      <button type="button" class="btn col-auto me-2 btn-secondary" (click)="closePopup()"><i class="fa fa-times"></i> Cancel</button>
      <button type="button" class="btn col-auto btn-primary" (click)="submitForm(repoBusinessForm.value)"
              [disabled]="isLoader">
        <i class="fa fa-save"></i> Save
      </button>
    </div>
  </div>
  <div class="modal-body">
    <!--<div class="row" *ngIf="isLoader">
      <div class="col-md-12 text-center">
        Loading <i class="fa fa-spinner fa-spin"></i>
      </div>
    </div>-->

    <form
      name="repoBusinessForm"
      class="p-4"
      [formGroup]="repoBusinessForm"
      novalidate
    >
      <div class="row g-2 mb-2">
        <div class="col-6">
          <label class="col-form-label">Business name</label>
          <div class="input-group mb-2">
            <input
              class="form-control"
              [ngClass]="{
                'form-required-border':
                  repoBusinessForm.get('businessName').invalid &&
                  (repoBusinessForm.get('businessName').dirty ||
                    repoBusinessForm.get('businessName').touched)
              }"
              type="text"
              placeholder="Business name"
              formControlName="businessName"
            />
          </div>
        </div>
        <div class="col-6">
          <label class="col-form-label">Website</label>
          <div class="input-group mb-2">
            <input
              type="text"
              class="form-control"
              [ngClass]="{
                'form-required-border':
                  repoBusinessForm.get('website').invalid &&
                  (repoBusinessForm.get('website').dirty ||
                    repoBusinessForm.get('website').touched)
              }"
              placeholder="Website"
              formControlName="website"
            />
          </div>
        </div>
      </div>

      <div class="row g-2 mb-2">
        <div class="col-md-12 mt-2">
          <label class="col-form-label">Address 1</label>
          <div class="input-group mb-2">
            <textarea
              type="text"
              class="form-control"
              [ngClass]="{
                'form-required-border':
                  repoBusinessForm.get('address').invalid &&
                  (repoBusinessForm.get('address').dirty ||
                    repoBusinessForm.get('address').touched)
              }"
              placeholder="Address"
              formControlName="address"
              cols="30"
              rows="2"
            >
            </textarea>
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <label class="col-form-label">Address 2</label>
          <div class="input-group mb-2">
            <textarea
              formControlName="addressLine2"
              placeholder="Address 2"
              cols="30"
              rows="2"
              class="form-control"
            >
            </textarea>
          </div>
        </div>

        <div class="col-lg-4 col-sm-6 mt-2">
          <label class="col-form-label">Suburb</label>
          <div class="input-group mb-2">
            <input
              type="text"
              formControlName="suburb"
              placeholder="Suburb"
              class="form-control"
              [ngClass]="{
                'form-required-border':
                  repoBusinessForm.get('suburb').invalid &&
                  repoBusinessForm.get('suburb').touched
              }"
            />
          </div>
        </div>
        <div class="col-lg-4 col-sm-6 mt-2">
          <label class="col-form-label">State</label>
          <div class="input-group mb-2">
            <input
              type="text"
              formControlName="stateName"
              placeholder="State"
              class="form-control"
              [ngClass]="{
                'form-required-border':
                  repoBusinessForm.get('stateName').invalid &&
                  repoBusinessForm.get('stateName').touched
              }"
            />
          </div>
        </div>
        <div class="col-lg-4 col-sm-6 mt-2">
          <label class="col-form-label">Postcode</label>
          <div class="input-group mb-2">
            <input
              type="number"
              formControlName="postCode"
              placeholder="Postcode"
              class="form-control"
              [ngClass]="{
                'form-required-border':
                  repoBusinessForm.get('postCode').invalid &&
                  repoBusinessForm.get('postCode').touched
              }"
            />
          </div>
        </div>
        <div class="col-lg-4 col-sm-6 mt-2">
          <label class="col-form-label">Country</label>
          <div class="input-group mb-2">
            <select
              class="form-select"
              id="basic-addon1"
              formControlName="countryName"
              [ngClass]="{
                'form-required-border':
                  repoBusinessForm.get('countryName').invalid &&
                  repoBusinessForm.get('countryName').touched
              }"
            >
              <option value="" selected="selected">
                {{ "Select Country..." }}
              </option>
              <option
                *ngFor="let country of countries"
                value="{{ country.countryName }}"
              >
                {{ country.countryName }}
              </option>
            </select>
          </div>
        </div>
      </div>

    </form>
  </div>
</div>
